import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClientSignIn } from "../axios/api"; 

// Async action to fetch only specific users (e.g., managers)
export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get("/rolebased/users"); 
      console.log(response.data, "fetchUsers-------------------------->");
      return response.data.users; 
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Error fetching users");
    }
  }
);

// ✅ New action to fetch all users
export const fetchAllUsers = createAsyncThunk(
  "users/fetchAllUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get("/userlist/all"); // Adjust endpoint as needed
      console.log("users/fetchAllUsers for ead")
      console.log(response.data.users, "fetchAllUsers");
      return response.data.users;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Error fetching all users");
    }
  }
);

export const getchatuserlist = createAsyncThunk(
  "users/getchatuserlist", // <-- use a unique type name
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.get("/chat/getchatuser");
      console.log("users/getchatuser for chat");
      return response.data.users;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Error fetching chat users");
    }
  }
);



const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    getchatuser:[],
    allUsers: [], // ✅ Added for storing all users
    status: "idle",
    selectedUser: null,
    error: null,
  },
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },

    clearSelectedUser: (state) => {
      state.selectedUser = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch specific users
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      
      // ✅ Fetch all users
      .addCase(fetchAllUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allUsers = action.payload;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

       .addCase(getchatuserlist.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getchatuserlist.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.getchatuser = action.payload;
      })
      .addCase(getchatuserlist.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
  },
});

export default usersSlice.reducer;

export const {
  setSelectedUser,
  clearSelectedUser
} = usersSlice.actions;
